import SvgProfile from "../../icons/SvgProfile";
import SvgArrowLeft from "../../icons/SvgArrowLeft";
import SvgArrowRight from "../../icons/SvgArrowRight";
import { memo, useMemo } from "react";
import { getUserId, scrollTop } from "../../utils/util";
import { useState } from "react";
import LoginModal from "../../components/topbar/LoginModal";

const AstroCardRender = ({
  data,
  navigate,
  handlePage,
  pageno,
  isCarosel = false,
  pageLimit,
  isLoad,
  isMobile,
  handleMore,
  handleConnect,
}) => {
  const [loginModalVisible, setLoginModalVisible] = useState(false);
  const [isInitial, setInitial] = useState(true);


  const handleRedirect = (astro) => {
    if (!getUserId()) {
      setLoginModalVisible(true);
    } else if (navigate) {
      localStorage.setItem("astro-details", JSON.stringify(astro));
      navigate("/astrologer-details");
    }
  };
      const handleGetKundali = () => {
      setInitial(false);
      setTimeout(() => {
        scrollTop();
      }, 200);
    };
  return (
    <div className="card-container">
        {loginModalVisible && (
        <LoginModal
          open={loginModalVisible}
          onHide={() => setLoginModalVisible(false)}
          handleGetKundali={handleGetKundali}
        />
            )}
      <div className="card-container-widget">
        {!isMobile && isCarosel && pageno !== 0 && (
          <div
            style={{
              position: "absolute",
              left: -20,
              opacity: pageno === 0 || isLoad ? 0.5 : 1,
              pointerEvents: pageno === 0 || isLoad ? "none" : "auto",
              zIndex: 9,
            }}
            className="arrow-icon left-arrow-icon"
            hidden={!pageno}
            onClick={() => {
              if (handlePage) {
                handlePage((p) => (p > 1 ? p - 1 : 0));
              }
            }}
          >
            <SvgArrowLeft />
          </div>
        )}
        {useMemo(() => {
          return (
            data &&
            data.map((astro, index) => {
              const status =
                astro.experienceInfo.callAvailablity &&
                astro.experienceInfo.chatAvilablity
                  ? "Online"
                  : "Offline";
              return (
                <div
                  className="consult-astro-card"
                  key={astro._id + index?.toString()}
                >
                  <div
                   onClick={() => handleRedirect(astro)}
                    className="image-container"
                  >
                    <div style={{ gap: 0 }} className="card-head">
                      {astro.profileUrl ? (
                        <div>
                          <img src={astro.profileUrl} alt="profile" />
                        </div>
                      ) : (
                        <div>
                          <SvgProfile />
                        </div>
                      )}
                    </div>

                    <div className="title-head">
                      <div className="card-head">
                        <div className="title-wrapper">
                          <div className="card-head-title-text">
                            {astro.fullName}
                          </div>
                        </div>
                        <button className={status}>{status}</button>
                      </div>
                      <div className="reviews">
                        <div className="rating">
                          {Number(astro.rating) === 0 ||
                          Number(astro.rating) === 5
                            ? astro.rating
                            : Number(astro.rating).toFixed(1)}{" "}
                          <img
                            style={{ width: 14, height: 14 }}
                            src={require("../../assets/svgs/star.svg").default}
                            alt="lang"
                          />
                        </div>
                        <p>{astro?.feedbackCount} Reviews</p>
                      </div>
                      <div className="tag-container">
                        {astro.experienceInfo.expertise
                          ?.slice(0, 2)
                          ?.map((lan) => {
                            return (
                              <div key={lan.dataName} className="tags">
                                <p>{lan.dataName}</p>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>

                  <div
                   onClick={() => handleRedirect(astro)}
                    className="user-details"
                  >
                    <div>
                      <img
                        style={{ height: 20, width: 20 }}
                        src={require("../../assets/svgs/lang.svg").default}
                        alt="lang"
                      />
                       <p>
                        {astro.language.map((ln) => ln.dataName).join(", ")}
                      </p>
                    </div>
                    <div>
                      <img
                        style={{ height: 20, width: 20 }}
                        src={require("../../assets/svgs/edu.svg").default}
                        alt="lang"
                      />
                      <p>Exp: {astro.experienceInfo.experience.dataName}</p>
                    </div>
                    <div>
                      <img
                        style={{ height: 20, width: 20 }}
                        src={
                          require("../../assets/svgs/phone-astro.svg").default
                        }
                        alt="lang"
                      />
                      <p>{astro.totalConsultations} Consultations Done</p>
                    </div>
                  </div>
                  <div
                   onClick={() => handleRedirect(astro)}
                    className="user-bio"
                  >
                    <p>Bio</p>
                    <p className="ellipsis-container">
                      {astro.experienceInfo.personalInfo}
                    </p>
                  </div>
                  <div className="price">
                    <p>₹ {astro.experienceInfo.callCharges}/min</p>
                    <button
                      onClick={() => {
                        handleConnect(astro);
                      }}
                    >
                      Connect
                    </button>
                  </div>
                </div>
              );
            })
          );
        }, [data])}

        {!isMobile && isCarosel && pageno + 1 !== pageLimit && (
          <div
            style={{
              position: "absolute",
              right: -20,
              opacity: pageno + 1 === pageLimit || isLoad ? 0.5 : 1,
              pointerEvents:
                pageno + 1 === pageLimit || isLoad ? "none" : "auto",
              zIndex: 9,
            }}
            className="arrow-icon right-arrow-icon"
            onClick={() => handlePage((p) => p + 1)}
          >
            <SvgArrowRight />
          </div>
        )}
      </div>
      {isMobile && handleMore && pageno + 1 !== pageLimit && (
        <div className="load-more">
          <button disabled={isLoad} onClick={() => handleMore(pageno + 1)}>
            See More
          </button>
        </div>
      )}
    </div>
  );
};

export default memo(AstroCardRender);
